import React, { ReactElement } from "react";
import styled from "styled-components";
import { FieldProps } from "formik";

interface InputBaseProps extends FieldProps {
    placeholder?: string;
    as?: any; // можно подставить MaskedInput
}

export const BaseInputSmall: React.FC<InputBaseProps> = ({
    field,
    form,
    placeholder,
    as,
    ...rest
}): ReactElement => {

    const error = (form.errors as any)?.[field.name];
    const touched = (form.touched as any)?.[field.name];
    const hasError = Boolean(error && touched);

    return (
        <Wrapper>
            <StyledInput
                as={as}
                {...field}
                {...rest}
                placeholder={placeholder}
                $hasError={hasError}
            />
        </Wrapper>
    );
};

const Wrapper = styled.div`
    margin-bottom: 12px;
`;

export const StyledInput = styled.input<{ $hasError?: boolean }>`
    width: 100%;
    background: none;
    border-radius: 16px;
    border: 1px solid ${({ $hasError }) => ($hasError ? "#ff4b4b" : "#E46DD6")};
    padding: 13px 22px;
    font-family: "Manrope";
    font-size: 16px;
    color: #feffff;
    appearance: none;
    -webkit-appearance: none;

    &:focus {
        outline: none;
        border-color: ${({ $hasError }) => ($hasError ? "#ff4b4b" : "#ff8be4")};
    }
`;

const ErrorText = styled.div`
    margin-top: 4px;
    font-size: 12px;
    color: #ff4b4b;
`;
